<template>
    <div>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">Configuraciones</h3>
        </div>
        <div class="card-body">
            <form autocomplete="off">
                <div class="form-body">
                    <div class="row">
                        


                        <div class="col-md-6">
                            <!-- migracion desarrollo sin terminar #1401 -->
                            <label class="control-label">Generar automáticamente codigo interno del producto</label>
                            <div class="form-group" :class="{'has-danger': errors.generate_internal_id}">
                                <el-switch v-model="form.generate_internal_id" active-text="Si" inactive-text="No" @change="submit"></el-switch>
                                <small class="form-control-feedback" v-if="errors.generate_internal_id" v-text="errors.generate_internal_id[0]"></small>
                            </div>
                        </div>
                        
                        <div class="col-md-6 mt-2">
                            <label class="control-label">
                                Revisión de inventario
                                <el-tooltip class="item"
                                            content="Revisión del inventario del sistema con el escaneado/registrado de forma manual - Disponible en módulo Inventario"
                                            effect="dark"
                                            placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <div class="form-group" :class="{'has-danger': errors.inventory_review}">
                                <el-switch v-model="form.inventory_review" active-text="Si" inactive-text="No" @change="submit"></el-switch>
                                <small class="form-control-feedback" v-if="errors.inventory_review" v-text="errors.inventory_review[0]"></small>
                            </div>
                        </div>

                        
                        

                        

                        

                        <div class="col-md-6 mt-2">
                            <label class="control-label">
                                Cambiar tipo de afectación masivamente
                            </label>
                            <div class="form-group">
                                <el-select
                                    filterable
                                    v-model="form.affection_global"
                                >
                                    <el-option v-for="option in data_affection"
                                        :key="option.id"
                                        :value="option.id"
                                        :label="option.description"
                                    ></el-option>
                                </el-select>
                                <br>
                                <el-button type="primary"
                                    size="mini"
                                    @click="changeAffectionGlobal"
                                    :loading="loading_btn_global"
                                    :disabled="!form.affection_global"
                                >Guardar</el-button>
                            </div>
                        </div>

                        <div class="col-md-6 mt-2">
                            <label class="control-label">
                                Cambiar IGV masivamente
                                <el-tooltip content="Afectará a los productos ya registrados" effect="dark" placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-select
                                    filterable
                                    v-model="has_igv"
                                >
                                    <el-option v-for="(option, index) in option_igv"
                                        :key="index"
                                        :value="option.id"
                                        :label="option.description"
                                    ></el-option>
                                </el-select>
                                <br>
                                <el-button type="primary"
                                    size="mini"
                                    @click="changeIgvGlobal"
                                    :loading="loading_btn_igv"
                                    :disabled="!has_igv"
                                >Guardar</el-button>
                        </div>

                        <div class="col-md-6 mt-2">
                            <label class="control-label">
                                Incluir valor de código interno al importar productos
                                <el-tooltip content="Si se activa, debe colocar un valor en la columna de código interno en el excel de importación."
                                    effect="dark" placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <div class="form-group" :class="{'has-danger': errors.internal_id_in_import}">
                                <el-switch v-model="form.internal_id_in_import" active-text="Si" inactive-text="No" @change="submit"></el-switch>
                                <small class="form-control-feedback" v-if="errors.internal_id_in_import" v-text="errors.internal_id_in_import[0]"></small>
                            </div>
                        </div>
                        <div class="col-md-6 mt-2">
                            <label class="control-label">
                                Ocultar productos inhabilitados
                                <el-tooltip class="item"
                                    content="Si está activado, no se listarán los productos que estén inhabilitados"
                                    effect="dark" placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <div class="form-group" :class="{'has-danger': errors.hide_disabled_items}">
                                <el-switch v-model="form.hide_disabled_items" active-text="Si" inactive-text="No" @change="submit"></el-switch>
                                <small class="form-control-feedback" v-if="errors.hide_disabled_items" v-text="errors.hide_disabled_items[0]"></small>
                            </div>
                        </div>

                        <div class="col-md-6 mt-2">
                            <label class="control-label">Importar Productos a inhabilitar</label>
                            <div class="form-group">
                                <el-button type="success" size="mini" @click="dialogDisable = true">
                                    <i class="fa fa-upload"></i> Imp. Productos a inhabilitar
                                </el-button>
                            </div>
                        </div>

                        <div class="col-md-6 mt-2">
                            <el-button type="primary"
                                    size="mini"
                                    @click="deleteItemCodeGlobal"
                                    :loading="loading_btn_item_code"
                                    
                                >Eliminar codigo sunat
                                <el-tooltip class="item"
                                            content="Eliminar el codigo sunat de todos los productos"
                                            effect="dark"
                                            placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </el-button>
                        </div>

                        <div class="title border-bottom col-md-12">
                            <h4>Restricción de stock
                                <el-tooltip class="item"
                                            content="Para Factura, Boleta y Nota de venta"
                                            effect="dark"
                                            placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </h4>
                            
                        </div>
                        <div class="col-md-6">
                            <label class="control-label">Restricción de stock al finalizar la transacción
                                
                                <el-tooltip class="item"
                                            content="Valida el stock de los productos al finalizar la transacción "
                                            effect="dark"
                                            placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>

                            </label>
                            <div class="form-group" :class="{'has-danger': errors.stock_control}">
                                <el-switch v-model="form.stock_control" active-text="Si" inactive-text="No" @change="changeStockControl"></el-switch>
                                <small class="form-control-feedback" v-if="errors.stock_control" v-text="errors.stock_control[0]"></small>
                            </div>
                        </div>
                        <div class="col-md-6 mt-2" >
                            <label class="control-label">
                                Validar stock al agregar producto
                                
                            </label>
                            <div class="form-group" :class="{'has-danger': errors.validate_stock_add_item}">
                                <el-switch v-model="form.validate_stock_add_item" active-text="Si" inactive-text="No" @change="submit"></el-switch>
                                <small class="form-control-feedback" v-if="errors.validate_stock_add_item" v-text="errors.validate_stock_add_item[0]"></small>
                            </div>
                        </div>
                        <div class="title border-bottom col-md-12">
                            <h4>Restricción de stock en cotizaciones</h4>
                        </div>
                        <div class="col-md-6 mt-2">
                            <label class="control-label">Restricción de stock en cotizaciones al finalizar la transacción
                                <el-tooltip class="item"
                                            content="Valida el stock de los productos al finalizar la transacción"
                                            effect="dark" placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <div class="form-group" :class="{'has-danger': errors.stock_control_quotation}">
                                <el-switch v-model="form.stock_control_quotation" active-text="Si" inactive-text="No"
                                        @change="changeStockControlQuotation"></el-switch>
                                <small class="form-control-feedback" v-if="errors.stock_control_quotation"
                                    v-text="errors.stock_control_quotation[0]"></small>
                            </div>
                        </div>

                        <div class="col-md-6 mt-2" >
                            <label class="control-label">Validar stock al agregar producto en cotizaciones
                                
                            </label>
                            <div class="form-group" :class="{'has-danger': errors.validate_stock_add_item_quotation}">
                                <el-switch v-model="form.validate_stock_add_item_quotation" active-text="Si" inactive-text="No"
                                        @change="submit"></el-switch>
                                <small class="form-control-feedback" v-if="errors.validate_stock_add_item_quotation"
                                    v-text="errors.validate_stock_add_item_quotation[0]"></small>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    </div>

    <el-dialog title="Importar Productos a Inhabilitar" :visible.sync="dialogDisable" width="450px" @closed="resetDisableDialog">
        <div>
            <p class="mb-1">Subir un archivo Excel con una sola columna de <strong>códigos internos</strong> de los productos a inhabilitar.</p>
            <div class="form-group mt-3">
                <label class="control-label"></label>
                <el-upload
                    ref="uploadDisable"
                    :auto-upload="false"
                    :multiple="false"
                    :limit="1"
                    :show-file-list="true"
                    accept=".xlsx,.xls">
                    <el-button slot="trigger" type="primary" size="small">Seleccione un archivo (.xlsx)</el-button>
                </el-upload>
            </div>
            <div class="mt-1 mb-2">
                

                <a class="text-dark mr-auto" href="/formats/formato_inhabilitar_productos.xlsx" target="_blank">
                     Descargar formato de ejemplo para importar <i class="fa fa-download"></i>
                </a>
            </div>
            <div class="form-group mt-2">
                <el-checkbox v-model="disableForm.update_barcode">
                    Generar nuevo codigo interno y codigo de barra
                </el-checkbox>
                <el-tooltip class="item"
                        content='Al inicio del codigo interno y codigo de barra actual se le agregara el texto "inhab" ejemplo: "inhab-codigo actual"'
                        effect="dark" placement="top-start">
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </div>
        </div>
        <span slot="footer">
            <el-button @click="dialogDisable = false" size="small">Cerrar</el-button>
            <el-button type="primary" size="small" :loading="loadingDisable" @click="processDisableItems">Procesar</el-button>
        </span>
    </el-dialog>
    </div>
</template>

<script>
    export default {
        props: ['data_affection'],
        data() {
            return {
                loading_submit: false,
                resource: 'inventories/configuration',
                errors: {},
                form: {},
                loading_btn_global: false,
                has_igv: null,
                option_igv: [
                    {
                        id: 1,
                        description: 'Incluye IGV'
                    },
                    {
                        id: 2,
                        description: 'No incluye IGV'
                    },
                ],
                loading_btn_igv: false,
                loading_btn_item_code: false,
                dialogDisable: false,
                loadingDisable: false,
                disableForm: {
                    update_barcode: false
                },
                disableResult: null
            }
        },
        async created() {
            await this.initForm();
            await this.getRecord()
            console.log(this.data_affection)
        },
        methods: {
            initForm() {
                this.errors = {};

                this.form = {
                    id: null,
                    stock_control: false,
                    inventory_review: false,
                    validate_stock_add_item: false,

                    affection_global: null,
                    hide_disabled_items: false,

                    stock_control_quotation: false,              
                    validate_stock_add_item_quotation: false,    
                };
            },
            async getRecord() {
                await this.$http.get(`/${this.resource}/record`) .then(response => {
                    if (response.data !== '') this.form = response.data.data;
                });
            },
            changeStockControl()
            {
                

                this.submit()
            },
            changeStockControlQuotation() {
            
            this.submit()
            },
            submit() {
                this.loading_submit = true;

                this.$http.post(`/${this.resource}`, this.form).then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    }
                    else {
                        this.$message.error(response.data.message);
                        this.getRecord()
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    }
                    else {
                        console.log(error);
                    }
                }).then(() => {
                    this.loading_submit = false;
                });
            },

            changeAffectionGlobal() {
                this.$confirm('¿Está seguro de cambiar el tipo de afectacion de los productos de manera masiva?', 'Advertencia', {
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No',
                    type: 'warning'
                })
                .then(() => {
                    this.loading_btn_global = true
                    this.$http.post(`/${this.resource}/update-affection`, this.form)
                        .then(response => {
                            if (response.data.success) {
                                this.$message.success(response.data.message)
                            } else {
                                this.$message.error(response.data.message)
                            }
                        })
                })
                .catch(() => {
                    
                })
                .finally(() => {
                    this.loading_btn_global = false
                })
            },

            async processDisableItems() {
                const uploadFiles = this.$refs.uploadDisable.uploadFiles
                const file = uploadFiles.length > 0 ? uploadFiles[0].raw : null
                if (!file) {
                    this.$message.warning('Seleccione un archivo Excel')
                    return
                }

                this.loadingDisable = true
                this.disableResult = null

                const formData = new FormData()
                formData.append('file', file)
                formData.append('update_barcode', this.disableForm.update_barcode ? 'true' : 'false')

                try {
                    const response = await this.$http.post('/inventories/configuration/disable-items-massive', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if (response.data.success) {
                        //this.$message.success(response.data.message)
                        
                        this.disableResult = response.data.data
                        this.$message({
                            type: 'success',
                            message: 'Proceso completado. Total: ' + this.disableResult.total + '<br> Inhabilitados: ' + this.disableResult.processed + '<br> Ignorados: ' + this.disableResult.skipped,
                            dangerouslyUseHTMLString: true
                        })
                        
                    } else {
                        this.$message.error(response.data.message)
                    }
                    
                } catch (error) {
                    this.$message.error('Ocurrió un error al procesar el archivo')
                } finally {
                    this.loadingDisable = false
                    this.dialogDisable = false
                }
            },

            resetDisableDialog() {
                this.disableResult = null
                this.disableForm.update_barcode = false
                if (this.$refs.uploadDisable) {
                    this.$refs.uploadDisable.clearFiles()
                }
            },


            async deleteItemCodeGlobal() {
                try {
                    await this.$confirm(
                        '¿Está seguro de eliminar el código SUNAT de todos los productos? Esta acción no se puede deshacer.',
                        'Advertencia',
                        {
                            confirmButtonText: 'Eliminar',
                            cancelButtonText: 'Cancelar',
                            type: 'warning'
                        }
                    )
                } catch (error) {
                    return
                }

                this.loading_btn_item_code = true

                try {
                    const response = await this.$http.post(
                        `/${this.resource}/delete-item-code`
                    )

                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                } catch (error) {
                    const message =
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                            ? error.response.data.message
                            : 'Ocurrió un error al eliminar el código SUNAT de los productos'

                    this.$message.error(message)
                } finally {
                    this.loading_btn_item_code = false
                }
            },
            async changeIgvGlobal() {
                this.loading_btn_igv = true
                const data = this.has_igv === 1 ? true : false
                try {
                    const response = await this.$http.post(`/${this.resource}/update-igv`, {
                        data
                    })
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                    } else {
                        this.$message.error(response.data.message)
                    }
                } catch (error) {

                } finally {
                    this.loading_btn_igv = false
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// modules/Inventory/Resources/assets/js/config/form.vue